// NotificationListener.jsx
import { useEffect } from "react";
import io from "socket.io-client";
import { useSnackbar } from "notistack";

const socket = io(process.env.REACT_APP_API_URL_SOCKET);

// Pre-Book Order alert. mp3, so there is no browser that cannot decode it -
// which is why there is no fallback here: the only thing left that makes play()
// reject is the browser blocking autoplay until the operator has clicked
// somewhere on the page, and no second file fixes that.
const PRE_BOOK_SOUND = "/pre-order-sound-v2.mp3";

export default function NotificationListener() {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const audio = new Audio("/notification.mpeg");
    // Pre-book gets its own sound so the two events stay tellable apart.
    const preBookAudio = new Audio(PRE_BOOK_SOUND);

    socket.on("purchase-order-created", (data) => {
      audio.play().catch(() => {});

      enqueueSnackbar(data.message, {
        variant: "success",
        autoHideDuration: 7000, // 7 seconds, increase as needed
      });
    });

    socket.on("pre-book-created", (data) => {
      preBookAudio.play().catch(() => {});

      enqueueSnackbar(data.message, {
        variant: "success",
        autoHideDuration: 7000, // 7 seconds, increase as needed
      });
    });

    // A vendor uploaded a payment proof from the App.
    socket.on("payment-proof-uploaded", (data) => {
      audio.play().catch(() => {});

      enqueueSnackbar(data.message, {
        variant: "info",
        autoHideDuration: 7000,
      });
    });

    return () => {
      socket.off("purchase-order-created");
      socket.off("pre-book-created");
      socket.off("payment-proof-uploaded");
    };
  }, [enqueueSnackbar]);

  return null;
}
